import React, { useContext } from 'react';
import { StickyContext } from 'core/modules/Partials/StickyMenu/context/StickyContext';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';
import MerchantClickUrlLink from 'core/modules/MerchantClickUrlLink/MerchantClickUrlLink';

import './MerchantInfoStickyTile.scss';

function MerchantInfoStickyTile({ merchant, config }) {
  const { stickyClassName, stickyHeaderHeight } = useContext(StickyContext);
  const {
    name, rebate, isDirect, showRebate,
  } = merchant;
  const { rebateOptions, directMerchantCTA } = config;
  const label = isDirect ? `${showRebate ? 'Shop with' : 'Save with'} ${directMerchantCTA}` : 'Shop now';

  return (
    <div className={`mn_merchantInfoStickyTile ${stickyClassName}`} style={{ top: `${stickyHeaderHeight}px` }}>
      <div>
        <div className="mn_merchantName">{name}</div>
        {showRebate && <PremierMerchantRebate {...rebate} {...rebateOptions} />}
      </div>
      <MerchantClickUrlLink className="mn_button mn_shopNowLink" merchant={merchant} defaultLabel={label} />
    </div>
  );
}

export default MerchantInfoStickyTile;
